import React, { useState, useEffect } from "react";
import { FaMapMarkerAlt, FaTint } from "react-icons/fa";
import "./Dashboard.scss";

function Dashboard() {
  const [username, setUsername] = useState("");
  const [time, setTime] = useState(new Date());
  const [weather, setWeather] = useState(null);
  const [humidity, setHumidity] = useState(null);

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const response = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=12.9716&longitude=77.5946&current_weather=true&hourly=relative_humidity_2m`
        );
        const data = await response.json();
        setWeather(data.current_weather);
        setHumidity(data.hourly.relative_humidity_2m[0]); // Extract first-hour humidity
      } catch (error) {
        console.error("Error fetching weather:", error);
      }
    };
    fetchWeather();
  }, []);

  return (
    <div className="dashboard">
      <div className="clock-container">
        <div className="clock">
          <p className="date">
            {time.toLocaleDateString("en-US", {
              weekday: "long",
              day: "numeric",
              month: "short",
            })}
          </p>
          <p className="time">
            {time.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </p>
        </div>
        <p className="greeting">Welcome {username || "Guest"}, Good Evening!</p>
      </div>

      <div className="weather-container">
        {weather ? (
          <div className="weather">
            <p className="temperature">{weather.temperature}°C</p>
            <p className="humidity">
              <FaTint /> Humidity {humidity ? `${humidity}%` : "N/A"}
            </p>
            <p className="location">
              <FaMapMarkerAlt /> Bengaluru
            </p>
          </div>
        ) : (
          <p>Loading weather...</p>
        )}
      </div>

      <div className="quote">
        <p>"I would rather die of passion than of boredom."</p>
        <span>- Vincent van Gogh</span>
      </div>
    </div>
  );
}

export default Dashboard;
